module.exports = __webpack_public_path__ + "static/food-mobile-3e3484c18f952ed03b1794f6fd6bd08d.png";